var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00039 4.6999L1.55039 7.1499C1.45872 7.24157 1.34206 7.2874 1.20039 7.2874C1.05872 7.2874 0.942057 7.24157 0.850391 7.1499C0.758724 7.05824 0.712891 6.94157 0.712891 6.7999C0.712891 6.65824 0.758724 6.54157 0.850391 6.4499L3.30039 3.9999L0.850391 1.5499C0.758724 1.45824 0.712891 1.34157 0.712891 1.1999C0.712891 1.05824 0.758724 0.941569 0.850391 0.849902C0.942057 0.758236 1.05872 0.712402 1.20039 0.712402C1.34206 0.712402 1.45872 0.758236 1.55039 0.849902L4.00039 3.2999L6.45039 0.849902C6.54206 0.758236 6.65872 0.712402 6.80039 0.712402C6.94206 0.712402 7.05872 0.758236 7.15039 0.849902C7.24206 0.941569 7.28789 1.05824 7.28789 1.1999C7.28789 1.34157 7.24206 1.45824 7.15039 1.5499L4.70039 3.9999L7.15039 6.4499C7.24206 6.54157 7.28789 6.65824 7.28789 6.7999C7.28789 6.94157 7.24206 7.05824 7.15039 7.1499C7.05872 7.24157 6.94206 7.2874 6.80039 7.2874C6.65872 7.2874 6.54206 7.24157 6.45039 7.1499L4.00039 4.6999Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3452e48ed15d8269946a8f94cb09f564.svg";
export { ForwardRef as ReactComponent };